"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRecording = exports.RecordingProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/**
 * Copyright 2025 Scott Bender (scott@scottbender.net)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const react_1 = require("react");
const RecordingContext = (0, react_1.createContext)(undefined);
const recordingReducer = (state, action) => {
    console.log('RecordingReducer state:', state);
    switch (action.type) {
        case 'RECORDING_STARTED':
            return {
                ...state,
                status: {
                    ...action.payload,
                    isRecording: true,
                },
                lastUpdate: new Date().toISOString(),
            };
        case 'RECORDING_STOPPED':
            return {
                ...state,
                status: {
                    ...action.payload,
                    isRecording: false,
                },
                lastUpdate: new Date().toISOString(),
            };
        case 'RECORDING_PROGRESS':
            return {
                ...state,
                status: {
                    ...state.status,
                    ...action.payload,
                },
                lastUpdate: new Date().toISOString(),
            };
        case 'RECORDING_ERROR':
            return {
                ...state,
                status: {
                    ...state.status,
                    error: action.payload.error,
                },
                lastUpdate: new Date().toISOString(),
            };
        case 'SET_STATUS':
            return {
                ...state,
                status: action.payload,
                lastUpdate: new Date().toISOString(),
            };
        default:
            return state;
    }
};
const initialState = {
    status: {
        isRecording: false,
        messageCount: 0,
        fileSize: 0,
    },
};
const RecordingProvider = ({ children }) => {
    const [state, dispatch] = (0, react_1.useReducer)(recordingReducer, initialState);
    return (0, jsx_runtime_1.jsx)(RecordingContext.Provider, { value: { state, dispatch }, children: children });
};
exports.RecordingProvider = RecordingProvider;
const useRecording = () => {
    const context = (0, react_1.useContext)(RecordingContext);
    if (context === undefined) {
        throw new Error('useRecording must be used within a RecordingProvider');
    }
    return context;
};
exports.useRecording = useRecording;
